import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faClock, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './Ubicacion.css';

export default function Ubicacion() {
    // Información del local - puedes personalizar estos datos
    const infoLocal = {
        direccion: "San martin 88, Oncativo Cordoba. Argentina",
        telefono: "+5493512440118",
        email: "bruno@filoniauto.com",
        horarios: [
            { dias: "Lunes a Viernes", horario: "9:00 a 13:00 y 16:00 a 20:00" },
            { dias: "Sábados", horario: "9:00 a 13:00" },
            { dias: "Domingos", horario: "Cerrado" }
        ]
    };

    const handleDireccionesClick = () => {
        // Abre Google Maps con la dirección
        const direccionEncoded = encodeURIComponent(infoLocal.direccion);
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${direccionEncoded}`, '_blank');
    };

    return (
        <div className='ubicacion-section'>
            <div className='ubicacion-container'>
                <div className='ubicacion-header'>
                    <h2 className='ubicacion-title'>UBICACION</h2>
                    <p className='ubicacion-subtitle'>
                        Visitanos en nuestro consecionario para <br />conocer todos los vehículos disponibles
                    </p>
                </div>

                <div className='ubicacion-content'>
                    <div className='ubicacion-info'>
                        <div className='info-card'>
                            <div className='info-item'>
                                <div className='info-icon-container'>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className='info-icon' />
                                </div>
                                <div className='info-content'>
                                    <h4 className='info-titulo'>Dirección</h4>
                                    <p className='info-descripcion'>{infoLocal.direccion}</p>
                                </div>
                            </div>

                            <div className='info-item'>
                                <div className='info-icon-container'>
                                    <FontAwesomeIcon icon={faPhone} className='info-icon' />
                                </div>
                                <div className='info-content'>
                                    <h4 className='info-titulo'>Teléfono</h4>
                                    <p className='info-descripcion'>{infoLocal.telefono}</p>
                                </div>
                            </div>

                            <div className='info-item'>
                                <div className='info-icon-container'>
                                    <FontAwesomeIcon icon={faEnvelope} className='info-icon' />
                                </div>
                                <div className='info-content'>
                                    <h4 className='info-titulo'>Email</h4>
                                    <p className='info-descripcion'>{infoLocal.email}</p>
                                </div>
                            </div>

                            {/* 🔹 Reemplazo del bloque de horarios */}
                            <div className='horarios-section'>
                                <div className='horarios-header'>
                                    <FontAwesomeIcon icon={faClock} className='horarios-icon' />
                                    <h4 className='horarios-titulo'>
                                        Agendá tu cita o visitanos <span style={{ fontWeight: 400 }}>(abierto de lunes a sábado)</span>
                                    </h4>
                                </div>
                            </div>

                            <button className='direcciones-btn' onClick={handleDireccionesClick}>
                                <FontAwesomeIcon icon={faMapMarkerAlt} />
                                Cómo llegar
                            </button>
                        </div>
                    </div>

                    <div className='ubicacion-mapa'>
                        <div className='mapa-container'>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3393.2842459293456!2d-63.5539572!3d-31.879793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95cd6f11c7619225%3A0xc092e07662c5b36!2sSan%20Mart%C3%ADn%2088%2C%20Oncativo%2C%20C%C3%B3rdoba%2C%20Argentina!5e0!3m2!1sen!2sus!4v1695240217032!5m2!1sen!2sus"
                                className='google-map'
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Ubicación Filoni Concesionario"
                            ></iframe>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}